module.exports = __webpack_public_path__ + "img/changer-lifestyle-before.969c69ed.jpg";